import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/mail-icon.svg'


const _hoisted_1 = { class: "social-contacts-wrapper" }
const _hoisted_2 = { class: "social-contacts-container" }
const _hoisted_3 = { class: "contact-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "social-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_socialButtons = _resolveComponent("socialButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: `mailto:` + _ctx.email,
          class: "default-text-contacts email-text"
        }, _toDisplayString(_ctx.email), 9, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_socialButtons)
      ])
    ])
  ]))
}